export default __webpack_public_path__ + "static/media/NirmalaB.018d125a.ttf";